<template>
  <ul class="nav flex-column">
    <li
      class="nav-item"
      v-for="item in getNavItems"
      :key="`nav-${item.name}`">
      <router-link
        :class="{ 'nav-link': true, 'active': isActiveParent(item), 'active-parent': isActiveParent(item) }"
        active-class="active"
        :to="{ name: item.name }"
        exact>
        {{ item.meta.title }}
      </router-link>
      <navigation-main v-if="isActiveParent(item)" class="pl-3" :nav-items="item.children" />
    </li>
  </ul>
</template>

<script>
export default {
  name: 'NavigationMain',

  props: {
    navItems: {
      type: Array,
      required: false,
      default() {
        return this.$router.options.routes;
      },
    },
  },

  computed: {
    getNavItems() {
      return this.navItems.filter(navItem => navItem.meta.showInNav);
    },
  },

  methods: {
    isActiveParent(item) {
      if (!item.children || !item.children.length) {
        return false;
      }

      const currentRouteArr = this.$route.path.split('/').filter(routePart => routePart !== '');
      const currentRouteAdminIndex = currentRouteArr.indexOf('admin');
      if (currentRouteAdminIndex !== -1) {
        currentRouteArr.splice(currentRouteAdminIndex, 1);
      }
      const itemPathArr = item.path.split('/').filter(routePart => routePart !== '');
      const itemPathArrAdminIndex = itemPathArr.indexOf('admin');
      if (itemPathArrAdminIndex !== -1) {
        itemPathArr.splice(itemPathArrAdminIndex, 1);
      }

      const filteredPath = currentRouteArr.filter(routePart => itemPathArr.indexOf(routePart) !== -1);

      if (!filteredPath.length) {
        return false;
      }

      return true;
    },
  },
};
</script>
